import insuranceApi from '~/app/modules/insurance/api/insurance.api';
import socialFundApi from '~/app/features/social-fund/services/api';
import rolloverApi from '~/app/features/rollover-otp/services/api';

export default ({ $api }) => {
  $api.register('http-public', '/web/public', request => ({
    getBiometryConfig() {
      return request('GET', '/biometry/config');
    },
  }));

  $api.register('http', '/web/private/client', request => ({
    createBiometry() {
      return request('POST', '/biometry');
    },
    getActualBiometryStatus() {
      return request('GET', '/biometry/actual');
    },
    uploadBiometryPhoto(payload) {
      return request('POST', '/biometry/file/upload', payload);
    },
    updateOfficeLocation(payload) {
      return request('POST', '/update-office-location', payload);
    },
    uploadDocument(payload) {
      return request('POST', '/document/file-upload', payload);
    },
    clientVerification(payload) {
      return request('GET', `/verification/select?option=${payload}`);
    },
    activeDocumentList() {
      return request('GET', '/active-documents/list');
    },
    activeDocument(payload) {
      return request('GET', `/active-documents/${payload.type}/${payload.id}/download`, {
        responseType: 'arraybuffer',
      });
    },
    blockAccount() {
      return request('POST', '/report-account-hacked');
    },
    approveIncrease(id, payload) {
      return request('PUT', `/yhat/offer/approve/increase/${id}`, payload);
    },
    approveDecrease(id) {
      return request('PUT', `/yhat/offer/approve/decrease/${id}`);
    },
    approveOperatorDecrease() {
      return request('POST', '/operator-decrease-offer/accept');
    },
    draftApplication(payload) {
      return request('POST', '/application/draft', payload);
    },
  }));

  socialFundApi($api);
  insuranceApi($api);
  rolloverApi($api);
};
